module.exports = __webpack_public_path__ + "fonts-3fa6903bffb17eadf7f0e0cae510433c-GT-Eesti-Pro-Display-Regular-Italic-subset.zopfli.woff";